/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type TBooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  contains?: InputMaybe<Scalars['Boolean']>;
  containsi?: InputMaybe<Scalars['Boolean']>;
  endsWith?: InputMaybe<Scalars['Boolean']>;
  eq?: InputMaybe<Scalars['Boolean']>;
  eqi?: InputMaybe<Scalars['Boolean']>;
  gt?: InputMaybe<Scalars['Boolean']>;
  gte?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  lt?: InputMaybe<Scalars['Boolean']>;
  lte?: InputMaybe<Scalars['Boolean']>;
  ne?: InputMaybe<Scalars['Boolean']>;
  nei?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<TBooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']>;
  notContainsi?: InputMaybe<Scalars['Boolean']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']>;
};

export type TCatalog = {
  __typename?: 'Catalog';
  checksum?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  pages?: Maybe<TPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  runFrom?: Maybe<Scalars['DateTime']>;
  runTo?: Maybe<Scalars['DateTime']>;
  stores?: Maybe<TStoreEntityResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TCatalogPagesArgs = {
  filters?: InputMaybe<TPageFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TCatalogStoresArgs = {
  distanceFilter?: InputMaybe<TDistanceFiltersInput>;
  filters?: InputMaybe<TStoreFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TCatalogEntity = {
  __typename?: 'CatalogEntity';
  attributes?: Maybe<TCatalog>;
  id?: Maybe<Scalars['ID']>;
};

export type TCatalogEntityResponse = {
  __typename?: 'CatalogEntityResponse';
  data?: Maybe<TCatalogEntity>;
};

export type TCatalogEntityResponseCollection = {
  __typename?: 'CatalogEntityResponseCollection';
  data: Array<TCatalogEntity>;
  meta: TResponseCollectionMeta;
};

export type TCatalogFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TCatalogFiltersInput>>>;
  checksum?: InputMaybe<TStringFilterInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  not?: InputMaybe<TCatalogFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TCatalogFiltersInput>>>;
  pages?: InputMaybe<TPageFiltersInput>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  runFrom?: InputMaybe<TDateTimeFilterInput>;
  runTo?: InputMaybe<TDateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  stores?: InputMaybe<TStoreFiltersInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TCatalogInput = {
  checksum?: InputMaybe<Scalars['String']>;
  pages?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  runFrom?: InputMaybe<Scalars['DateTime']>;
  runTo?: InputMaybe<Scalars['DateTime']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  stores?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type TCatalogRelationResponseCollection = {
  __typename?: 'CatalogRelationResponseCollection';
  data: Array<TCatalogEntity>;
};

export type TCategory = {
  __typename?: 'Category';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TCategoryEntity = {
  __typename?: 'CategoryEntity';
  attributes?: Maybe<TCategory>;
  id?: Maybe<Scalars['ID']>;
};

export type TCategoryEntityResponse = {
  __typename?: 'CategoryEntityResponse';
  data?: Maybe<TCategoryEntity>;
};

export type TCategoryEntityResponseCollection = {
  __typename?: 'CategoryEntityResponseCollection';
  data: Array<TCategoryEntity>;
  meta: TResponseCollectionMeta;
};

export type TCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TCategoryFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  slug?: InputMaybe<TStringFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TCategoryInput = {
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type TCategoryRelationResponseCollection = {
  __typename?: 'CategoryRelationResponseCollection';
  data: Array<TCategoryEntity>;
};

export type TComponentMiscCarouselBanner = {
  __typename?: 'ComponentMiscCarouselBanner';
  id: Scalars['ID'];
  image?: Maybe<TUploadFileEntityResponse>;
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TComponentMiscCarouselBannerFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TComponentMiscCarouselBannerFiltersInput>>>;
  not?: InputMaybe<TComponentMiscCarouselBannerFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TComponentMiscCarouselBannerFiltersInput>>>;
  subtitle?: InputMaybe<TStringFilterInput>;
  title?: InputMaybe<TStringFilterInput>;
  url?: InputMaybe<TStringFilterInput>;
};

export type TComponentMiscCarouselBannerInput = {
  id?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['ID']>;
  subtitle?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type TComponentMiscOfferCollection = {
  __typename?: 'ComponentMiscOfferCollection';
  id: Scalars['ID'];
  offerings?: Maybe<Array<Maybe<TComponentMiscOrgs>>>;
  title?: Maybe<Scalars['String']>;
};


export type TComponentMiscOfferCollectionOfferingsArgs = {
  filters?: InputMaybe<TComponentMiscOrgsFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TComponentMiscOfferCollectionInput = {
  id?: InputMaybe<Scalars['ID']>;
  offerings?: InputMaybe<Array<InputMaybe<TComponentMiscOrgsInput>>>;
  title?: InputMaybe<Scalars['String']>;
};

export type TComponentMiscOrgs = {
  __typename?: 'ComponentMiscOrgs';
  active?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  organization?: Maybe<TOrganizationEntityResponse>;
};

export type TComponentMiscOrgsFiltersInput = {
  active?: InputMaybe<TBooleanFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TComponentMiscOrgsFiltersInput>>>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TComponentMiscOrgsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TComponentMiscOrgsFiltersInput>>>;
  organization?: InputMaybe<TOrganizationFiltersInput>;
};

export type TComponentMiscOrgsInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
};

export type TComponentMiscPartners = {
  __typename?: 'ComponentMiscPartners';
  id: Scalars['ID'];
  linkLabel?: Maybe<Scalars['String']>;
  linkUrl?: Maybe<Scalars['String']>;
};

export type TComponentMiscPartnersFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TComponentMiscPartnersFiltersInput>>>;
  linkLabel?: InputMaybe<TStringFilterInput>;
  linkUrl?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TComponentMiscPartnersFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TComponentMiscPartnersFiltersInput>>>;
};

export type TComponentMiscPartnersInput = {
  id?: InputMaybe<Scalars['ID']>;
  linkLabel?: InputMaybe<Scalars['String']>;
  linkUrl?: InputMaybe<Scalars['String']>;
};

export type TCountry = {
  __typename?: 'Country';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  regions?: Maybe<TRegionRelationResponseCollection>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TCountryRegionsArgs = {
  filters?: InputMaybe<TRegionFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TCountryEntity = {
  __typename?: 'CountryEntity';
  attributes?: Maybe<TCountry>;
  id?: Maybe<Scalars['ID']>;
};

export type TCountryEntityResponse = {
  __typename?: 'CountryEntityResponse';
  data?: Maybe<TCountryEntity>;
};

export type TCountryEntityResponseCollection = {
  __typename?: 'CountryEntityResponseCollection';
  data: Array<TCountryEntity>;
  meta: TResponseCollectionMeta;
};

export type TCountryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TCountryFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TCountryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TCountryFiltersInput>>>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  regions?: InputMaybe<TRegionFiltersInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  slug?: InputMaybe<TStringFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TCountryInput = {
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type TDateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  contains?: InputMaybe<Scalars['DateTime']>;
  containsi?: InputMaybe<Scalars['DateTime']>;
  endsWith?: InputMaybe<Scalars['DateTime']>;
  eq?: InputMaybe<Scalars['DateTime']>;
  eqi?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  ne?: InputMaybe<Scalars['DateTime']>;
  nei?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<TDateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']>;
  notContainsi?: InputMaybe<Scalars['DateTime']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']>;
};

export type TDistanceFiltersInput = {
  distance?: InputMaybe<Scalars['Float']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum TEnum_Sitemapsitemap_Type {
  DefaultHreflang = 'default_hreflang',
  Index = 'index'
}

export type TFaqPage = {
  __typename?: 'FaqPage';
  createdAt?: Maybe<Scalars['DateTime']>;
  markdown?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TFaqPageEntity = {
  __typename?: 'FaqPageEntity';
  attributes?: Maybe<TFaqPage>;
  id?: Maybe<Scalars['ID']>;
};

export type TFaqPageEntityResponse = {
  __typename?: 'FaqPageEntityResponse';
  data?: Maybe<TFaqPageEntity>;
};

export type TFaqPageInput = {
  markdown?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
};

export type TFileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type TFloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  contains?: InputMaybe<Scalars['Float']>;
  containsi?: InputMaybe<Scalars['Float']>;
  endsWith?: InputMaybe<Scalars['Float']>;
  eq?: InputMaybe<Scalars['Float']>;
  eqi?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  ne?: InputMaybe<Scalars['Float']>;
  nei?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<TFloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']>;
  notContainsi?: InputMaybe<Scalars['Float']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']>>>;
  startsWith?: InputMaybe<Scalars['Float']>;
};

export type TGenericMorph = TCatalog | TCategory | TComponentMiscCarouselBanner | TComponentMiscOfferCollection | TComponentMiscOrgs | TComponentMiscPartners | TCountry | TFaqPage | TI18NLocale | TLandingPage | TLocation | TOrganization | TPage | TPostalCode | TRegion | TSitemapSitemap | TSitemapSitemapCache | TStore | TTown | TUploadFile | TUploadFolder | TUserProfile | TUsersPermissionsPermission | TUsersPermissionsRole | TUsersPermissionsUser;

export type TI18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TI18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<TI18NLocale>;
  id?: Maybe<Scalars['ID']>;
};

export type TI18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<TI18NLocaleEntity>;
};

export type TI18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<TI18NLocaleEntity>;
  meta: TResponseCollectionMeta;
};

export type TI18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TI18NLocaleFiltersInput>>>;
  code?: InputMaybe<TStringFilterInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TI18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TI18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TIdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  contains?: InputMaybe<Scalars['ID']>;
  containsi?: InputMaybe<Scalars['ID']>;
  endsWith?: InputMaybe<Scalars['ID']>;
  eq?: InputMaybe<Scalars['ID']>;
  eqi?: InputMaybe<Scalars['ID']>;
  gt?: InputMaybe<Scalars['ID']>;
  gte?: InputMaybe<Scalars['ID']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  lt?: InputMaybe<Scalars['ID']>;
  lte?: InputMaybe<Scalars['ID']>;
  ne?: InputMaybe<Scalars['ID']>;
  nei?: InputMaybe<Scalars['ID']>;
  not?: InputMaybe<TIdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']>;
  notContainsi?: InputMaybe<Scalars['ID']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startsWith?: InputMaybe<Scalars['ID']>;
};

export type TIntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  contains?: InputMaybe<Scalars['Int']>;
  containsi?: InputMaybe<Scalars['Int']>;
  endsWith?: InputMaybe<Scalars['Int']>;
  eq?: InputMaybe<Scalars['Int']>;
  eqi?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  ne?: InputMaybe<Scalars['Int']>;
  nei?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<TIntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']>;
  notContainsi?: InputMaybe<Scalars['Int']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  startsWith?: InputMaybe<Scalars['Int']>;
};

export type TJsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  contains?: InputMaybe<Scalars['JSON']>;
  containsi?: InputMaybe<Scalars['JSON']>;
  endsWith?: InputMaybe<Scalars['JSON']>;
  eq?: InputMaybe<Scalars['JSON']>;
  eqi?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  ne?: InputMaybe<Scalars['JSON']>;
  nei?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<TJsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']>;
  notContainsi?: InputMaybe<Scalars['JSON']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  startsWith?: InputMaybe<Scalars['JSON']>;
};

export type TLandingPage = {
  __typename?: 'LandingPage';
  carouselBanner?: Maybe<Array<Maybe<TComponentMiscCarouselBanner>>>;
  categories?: Maybe<TCategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  offerCollection?: Maybe<TComponentMiscOfferCollection>;
  partners?: Maybe<Array<Maybe<TComponentMiscPartners>>>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TLandingPageCarouselBannerArgs = {
  filters?: InputMaybe<TComponentMiscCarouselBannerFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TLandingPageCategoriesArgs = {
  filters?: InputMaybe<TCategoryFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TLandingPagePartnersArgs = {
  filters?: InputMaybe<TComponentMiscPartnersFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TLandingPageEntity = {
  __typename?: 'LandingPageEntity';
  attributes?: Maybe<TLandingPage>;
  id?: Maybe<Scalars['ID']>;
};

export type TLandingPageEntityResponse = {
  __typename?: 'LandingPageEntityResponse';
  data?: Maybe<TLandingPageEntity>;
};

export type TLandingPageInput = {
  carouselBanner?: InputMaybe<Array<InputMaybe<TComponentMiscCarouselBannerInput>>>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offerCollection?: InputMaybe<TComponentMiscOfferCollectionInput>;
  partners?: InputMaybe<Array<InputMaybe<TComponentMiscPartnersInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
};

export type TLocation = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  distance?: Maybe<Scalars['Float']>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  postalCode?: Maybe<TPostalCodeEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  region?: Maybe<TRegionEntityResponse>;
  town?: Maybe<TTownEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TLocationDistanceArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type TLocationEntity = {
  __typename?: 'LocationEntity';
  attributes?: Maybe<TLocation>;
  id?: Maybe<Scalars['ID']>;
};

export type TLocationEntityResponse = {
  __typename?: 'LocationEntityResponse';
  data?: Maybe<TLocationEntity>;
};

export type TLocationEntityResponseCollection = {
  __typename?: 'LocationEntityResponseCollection';
  data: Array<TLocationEntity>;
  meta: TResponseCollectionMeta;
};

export type TLocationFiltersInput = {
  address?: InputMaybe<TStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TLocationFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  latitude?: InputMaybe<TFloatFilterInput>;
  longitude?: InputMaybe<TFloatFilterInput>;
  not?: InputMaybe<TLocationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TLocationFiltersInput>>>;
  postalCode?: InputMaybe<TPostalCodeFiltersInput>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  region?: InputMaybe<TRegionFiltersInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  town?: InputMaybe<TTownFiltersInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TLocationInput = {
  address?: InputMaybe<Scalars['String']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  postalCode?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  region?: InputMaybe<Scalars['ID']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  town?: InputMaybe<Scalars['ID']>;
};

export type TMutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<TUsersPermissionsLoginPayload>;
  createCatalog?: Maybe<TCatalogEntityResponse>;
  createCategory?: Maybe<TCategoryEntityResponse>;
  createCountry?: Maybe<TCountryEntityResponse>;
  createLocation?: Maybe<TLocationEntityResponse>;
  createOrganization?: Maybe<TOrganizationEntityResponse>;
  createPage?: Maybe<TPageEntityResponse>;
  createPostalCode?: Maybe<TPostalCodeEntityResponse>;
  createRegion?: Maybe<TRegionEntityResponse>;
  createSitemapSitemap?: Maybe<TSitemapSitemapEntityResponse>;
  createSitemapSitemapCache?: Maybe<TSitemapSitemapCacheEntityResponse>;
  createStore?: Maybe<TStoreEntityResponse>;
  createTown?: Maybe<TTownEntityResponse>;
  createUploadFile?: Maybe<TUploadFileEntityResponse>;
  createUploadFolder?: Maybe<TUploadFolderEntityResponse>;
  createUserProfile?: Maybe<TUserProfileEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<TUsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: TUsersPermissionsUserEntityResponse;
  deleteCatalog?: Maybe<TCatalogEntityResponse>;
  deleteCategory?: Maybe<TCategoryEntityResponse>;
  deleteCountry?: Maybe<TCountryEntityResponse>;
  deleteFaqPage?: Maybe<TFaqPageEntityResponse>;
  deleteLandingPage?: Maybe<TLandingPageEntityResponse>;
  deleteLocation?: Maybe<TLocationEntityResponse>;
  deleteOrganization?: Maybe<TOrganizationEntityResponse>;
  deletePage?: Maybe<TPageEntityResponse>;
  deletePostalCode?: Maybe<TPostalCodeEntityResponse>;
  deleteRegion?: Maybe<TRegionEntityResponse>;
  deleteSitemapSitemap?: Maybe<TSitemapSitemapEntityResponse>;
  deleteSitemapSitemapCache?: Maybe<TSitemapSitemapCacheEntityResponse>;
  deleteStore?: Maybe<TStoreEntityResponse>;
  deleteTown?: Maybe<TTownEntityResponse>;
  deleteUploadFile?: Maybe<TUploadFileEntityResponse>;
  deleteUploadFolder?: Maybe<TUploadFolderEntityResponse>;
  deleteUserProfile?: Maybe<TUserProfileEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<TUsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: TUsersPermissionsUserEntityResponse;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<TUsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<TUsersPermissionsPasswordPayload>;
  login: TUsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<TUploadFileEntityResponse>>;
  /** Register a user */
  register: TUsersPermissionsLoginPayload;
  removeFile?: Maybe<TUploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<TUsersPermissionsLoginPayload>;
  updateCatalog?: Maybe<TCatalogEntityResponse>;
  updateCategory?: Maybe<TCategoryEntityResponse>;
  updateCountry?: Maybe<TCountryEntityResponse>;
  updateFaqPage?: Maybe<TFaqPageEntityResponse>;
  updateFileInfo: TUploadFileEntityResponse;
  updateLandingPage?: Maybe<TLandingPageEntityResponse>;
  updateLocation?: Maybe<TLocationEntityResponse>;
  /** Update current logged user */
  updateMe: TUsersPermissionsUserEntityResponse;
  updateOrganization?: Maybe<TOrganizationEntityResponse>;
  updatePage?: Maybe<TPageEntityResponse>;
  updatePostalCode?: Maybe<TPostalCodeEntityResponse>;
  updateRegion?: Maybe<TRegionEntityResponse>;
  updateSitemapSitemap?: Maybe<TSitemapSitemapEntityResponse>;
  updateSitemapSitemapCache?: Maybe<TSitemapSitemapCacheEntityResponse>;
  updateStore?: Maybe<TStoreEntityResponse>;
  updateTown?: Maybe<TTownEntityResponse>;
  updateUploadFile?: Maybe<TUploadFileEntityResponse>;
  updateUploadFolder?: Maybe<TUploadFolderEntityResponse>;
  updateUserProfile?: Maybe<TUserProfileEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<TUsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: TUsersPermissionsUserEntityResponse;
  upload: TUploadFileEntityResponse;
};


export type TMutationChangePasswordArgs = {
  currentPassword: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type TMutationCreateCatalogArgs = {
  data: TCatalogInput;
};


export type TMutationCreateCategoryArgs = {
  data: TCategoryInput;
};


export type TMutationCreateCountryArgs = {
  data: TCountryInput;
};


export type TMutationCreateLocationArgs = {
  data: TLocationInput;
};


export type TMutationCreateOrganizationArgs = {
  data: TOrganizationInput;
};


export type TMutationCreatePageArgs = {
  data: TPageInput;
};


export type TMutationCreatePostalCodeArgs = {
  data: TPostalCodeInput;
};


export type TMutationCreateRegionArgs = {
  data: TRegionInput;
};


export type TMutationCreateSitemapSitemapArgs = {
  data: TSitemapSitemapInput;
};


export type TMutationCreateSitemapSitemapCacheArgs = {
  data: TSitemapSitemapCacheInput;
};


export type TMutationCreateStoreArgs = {
  data: TStoreInput;
};


export type TMutationCreateTownArgs = {
  data: TTownInput;
};


export type TMutationCreateUploadFileArgs = {
  data: TUploadFileInput;
};


export type TMutationCreateUploadFolderArgs = {
  data: TUploadFolderInput;
};


export type TMutationCreateUserProfileArgs = {
  data: TUserProfileInput;
};


export type TMutationCreateUsersPermissionsRoleArgs = {
  data: TUsersPermissionsRoleInput;
};


export type TMutationCreateUsersPermissionsUserArgs = {
  data: TUsersPermissionsUserInput;
};


export type TMutationDeleteCatalogArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteCategoryArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteCountryArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteLocationArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteOrganizationArgs = {
  id: Scalars['ID'];
};


export type TMutationDeletePageArgs = {
  id: Scalars['ID'];
};


export type TMutationDeletePostalCodeArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteRegionArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteSitemapSitemapArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteSitemapSitemapCacheArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteStoreArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteTownArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteUploadFileArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteUploadFolderArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteUserProfileArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID'];
};


export type TMutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID'];
};


export type TMutationEmailConfirmationArgs = {
  confirmation: Scalars['String'];
};


export type TMutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type TMutationLoginArgs = {
  input: TUsersPermissionsLoginInput;
};


export type TMutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  files: Array<InputMaybe<Scalars['Upload']>>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};


export type TMutationRegisterArgs = {
  input: TUsersPermissionsRegisterInput;
};


export type TMutationRemoveFileArgs = {
  id: Scalars['ID'];
};


export type TMutationResetPasswordArgs = {
  code: Scalars['String'];
  password: Scalars['String'];
  passwordConfirmation: Scalars['String'];
};


export type TMutationUpdateCatalogArgs = {
  data: TCatalogInput;
  id: Scalars['ID'];
};


export type TMutationUpdateCategoryArgs = {
  data: TCategoryInput;
  id: Scalars['ID'];
};


export type TMutationUpdateCountryArgs = {
  data: TCountryInput;
  id: Scalars['ID'];
};


export type TMutationUpdateFaqPageArgs = {
  data: TFaqPageInput;
};


export type TMutationUpdateFileInfoArgs = {
  id: Scalars['ID'];
  info?: InputMaybe<TFileInfoInput>;
};


export type TMutationUpdateLandingPageArgs = {
  data: TLandingPageInput;
};


export type TMutationUpdateLocationArgs = {
  data: TLocationInput;
  id: Scalars['ID'];
};


export type TMutationUpdateMeArgs = {
  data: TUsersPermissionsUserInput;
};


export type TMutationUpdateOrganizationArgs = {
  data: TOrganizationInput;
  id: Scalars['ID'];
};


export type TMutationUpdatePageArgs = {
  data: TPageInput;
  id: Scalars['ID'];
};


export type TMutationUpdatePostalCodeArgs = {
  data: TPostalCodeInput;
  id: Scalars['ID'];
};


export type TMutationUpdateRegionArgs = {
  data: TRegionInput;
  id: Scalars['ID'];
};


export type TMutationUpdateSitemapSitemapArgs = {
  data: TSitemapSitemapInput;
  id: Scalars['ID'];
};


export type TMutationUpdateSitemapSitemapCacheArgs = {
  data: TSitemapSitemapCacheInput;
  id: Scalars['ID'];
};


export type TMutationUpdateStoreArgs = {
  data: TStoreInput;
  id: Scalars['ID'];
};


export type TMutationUpdateTownArgs = {
  data: TTownInput;
  id: Scalars['ID'];
};


export type TMutationUpdateUploadFileArgs = {
  data: TUploadFileInput;
  id: Scalars['ID'];
};


export type TMutationUpdateUploadFolderArgs = {
  data: TUploadFolderInput;
  id: Scalars['ID'];
};


export type TMutationUpdateUserProfileArgs = {
  data: TUserProfileInput;
  id: Scalars['ID'];
};


export type TMutationUpdateUsersPermissionsRoleArgs = {
  data: TUsersPermissionsRoleInput;
  id: Scalars['ID'];
};


export type TMutationUpdateUsersPermissionsUserArgs = {
  data: TUsersPermissionsUserInput;
  id: Scalars['ID'];
};


export type TMutationUploadArgs = {
  field?: InputMaybe<Scalars['String']>;
  file: Scalars['Upload'];
  info?: InputMaybe<TFileInfoInput>;
  ref?: InputMaybe<Scalars['String']>;
  refId?: InputMaybe<Scalars['ID']>;
};

export type TOrganization = {
  __typename?: 'Organization';
  categories?: Maybe<TCategoryRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  expectedCatalogsUpdateFrequency?: Maybe<Scalars['Int']>;
  logo?: Maybe<TUploadFileEntityResponse>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  sameAs?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  stores?: Maybe<TStoreEntityResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TOrganizationCategoriesArgs = {
  filters?: InputMaybe<TCategoryFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TOrganizationStoresArgs = {
  distanceFilter?: InputMaybe<TDistanceFiltersInput>;
  filters?: InputMaybe<TStoreFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TOrganizationEntity = {
  __typename?: 'OrganizationEntity';
  attributes?: Maybe<TOrganization>;
  id?: Maybe<Scalars['ID']>;
};

export type TOrganizationEntityResponse = {
  __typename?: 'OrganizationEntityResponse';
  data?: Maybe<TOrganizationEntity>;
};

export type TOrganizationEntityResponseCollection = {
  __typename?: 'OrganizationEntityResponseCollection';
  data: Array<TOrganizationEntity>;
  meta: TResponseCollectionMeta;
};

export type TOrganizationFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TOrganizationFiltersInput>>>;
  categories?: InputMaybe<TCategoryFiltersInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  description?: InputMaybe<TStringFilterInput>;
  expectedCatalogsUpdateFrequency?: InputMaybe<TIntFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TOrganizationFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TOrganizationFiltersInput>>>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  sameAs?: InputMaybe<TStringFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  slug?: InputMaybe<TStringFilterInput>;
  stores?: InputMaybe<TStoreFiltersInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TOrganizationInput = {
  categories?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  expectedCatalogsUpdateFrequency?: InputMaybe<Scalars['Int']>;
  logo?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sameAs?: InputMaybe<Scalars['String']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  stores?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type TPage = {
  __typename?: 'Page';
  catalog?: Maybe<TCatalogEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  image?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TPageEntity = {
  __typename?: 'PageEntity';
  attributes?: Maybe<TPage>;
  id?: Maybe<Scalars['ID']>;
};

export type TPageEntityResponse = {
  __typename?: 'PageEntityResponse';
  data?: Maybe<TPageEntity>;
};

export type TPageEntityResponseCollection = {
  __typename?: 'PageEntityResponseCollection';
  data: Array<TPageEntity>;
  meta: TResponseCollectionMeta;
};

export type TPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TPageFiltersInput>>>;
  catalog?: InputMaybe<TCatalogFiltersInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  image?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TPageFiltersInput>>>;
  position?: InputMaybe<TIntFilterInput>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TPageInput = {
  catalog?: InputMaybe<Scalars['ID']>;
  image?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
};

export type TPageRelationResponseCollection = {
  __typename?: 'PageRelationResponseCollection';
  data: Array<TPageEntity>;
};

export type TPagination = {
  __typename?: 'Pagination';
  page: Scalars['Int'];
  pageCount: Scalars['Int'];
  pageSize: Scalars['Int'];
  total: Scalars['Int'];
};

export type TPaginationArg = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['Int']>;
};

export type TPostalCode = {
  __typename?: 'PostalCode';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TPostalCodeEntity = {
  __typename?: 'PostalCodeEntity';
  attributes?: Maybe<TPostalCode>;
  id?: Maybe<Scalars['ID']>;
};

export type TPostalCodeEntityResponse = {
  __typename?: 'PostalCodeEntityResponse';
  data?: Maybe<TPostalCodeEntity>;
};

export type TPostalCodeEntityResponseCollection = {
  __typename?: 'PostalCodeEntityResponseCollection';
  data: Array<TPostalCodeEntity>;
  meta: TResponseCollectionMeta;
};

export type TPostalCodeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TPostalCodeFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TPostalCodeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TPostalCodeFiltersInput>>>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TPostalCodeInput = {
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
};

export enum TPublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type TQuery = {
  __typename?: 'Query';
  catalog?: Maybe<TCatalogEntityResponse>;
  catalogs?: Maybe<TCatalogEntityResponseCollection>;
  categories?: Maybe<TCategoryEntityResponseCollection>;
  category?: Maybe<TCategoryEntityResponse>;
  countries?: Maybe<TCountryEntityResponseCollection>;
  country?: Maybe<TCountryEntityResponse>;
  faqPage?: Maybe<TFaqPageEntityResponse>;
  i18NLocale?: Maybe<TI18NLocaleEntityResponse>;
  i18NLocales?: Maybe<TI18NLocaleEntityResponseCollection>;
  landingPage?: Maybe<TLandingPageEntityResponse>;
  location?: Maybe<TLocationEntityResponse>;
  locations?: Maybe<TLocationEntityResponseCollection>;
  me?: Maybe<TUsersPermissionsMe>;
  organization?: Maybe<TOrganizationEntityResponse>;
  organizations?: Maybe<TOrganizationEntityResponseCollection>;
  page?: Maybe<TPageEntityResponse>;
  pages?: Maybe<TPageEntityResponseCollection>;
  postalCode?: Maybe<TPostalCodeEntityResponse>;
  postalCodes?: Maybe<TPostalCodeEntityResponseCollection>;
  region?: Maybe<TRegionEntityResponse>;
  regions?: Maybe<TRegionEntityResponseCollection>;
  sitemapSitemap?: Maybe<TSitemapSitemapEntityResponse>;
  sitemapSitemapCache?: Maybe<TSitemapSitemapCacheEntityResponse>;
  sitemapSitemapCaches?: Maybe<TSitemapSitemapCacheEntityResponseCollection>;
  sitemapSitemaps?: Maybe<TSitemapSitemapEntityResponseCollection>;
  store?: Maybe<TStoreEntityResponse>;
  stores?: Maybe<TStoreEntityResponseCollection>;
  town?: Maybe<TTownEntityResponse>;
  towns?: Maybe<TTownEntityResponseCollection>;
  uploadFile?: Maybe<TUploadFileEntityResponse>;
  uploadFiles?: Maybe<TUploadFileEntityResponseCollection>;
  uploadFolder?: Maybe<TUploadFolderEntityResponse>;
  uploadFolders?: Maybe<TUploadFolderEntityResponseCollection>;
  userProfile?: Maybe<TUserProfileEntityResponse>;
  userProfiles?: Maybe<TUserProfileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<TUsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<TUsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<TUsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<TUsersPermissionsUserEntityResponseCollection>;
};


export type TQueryCatalogArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryCatalogsArgs = {
  filters?: InputMaybe<TCatalogFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryCategoriesArgs = {
  filters?: InputMaybe<TCategoryFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryCategoryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryCountriesArgs = {
  filters?: InputMaybe<TCountryFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryCountryArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryFaqPageArgs = {
  publicationState?: InputMaybe<TPublicationState>;
};


export type TQueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryI18NLocalesArgs = {
  filters?: InputMaybe<TI18NLocaleFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryLandingPageArgs = {
  publicationState?: InputMaybe<TPublicationState>;
};


export type TQueryLocationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryLocationsArgs = {
  filters?: InputMaybe<TLocationFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryOrganizationArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryOrganizationsArgs = {
  filters?: InputMaybe<TOrganizationFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryPageArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryPagesArgs = {
  filters?: InputMaybe<TPageFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryPostalCodeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryPostalCodesArgs = {
  filters?: InputMaybe<TPostalCodeFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryRegionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryRegionsArgs = {
  filters?: InputMaybe<TRegionFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQuerySitemapSitemapArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQuerySitemapSitemapCacheArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQuerySitemapSitemapCachesArgs = {
  filters?: InputMaybe<TSitemapSitemapCacheFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQuerySitemapSitemapsArgs = {
  filters?: InputMaybe<TSitemapSitemapFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryStoreArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryStoresArgs = {
  distanceFilter?: InputMaybe<TDistanceFiltersInput>;
  filters?: InputMaybe<TStoreFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryTownArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryTownsArgs = {
  filters?: InputMaybe<TTownFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryUploadFilesArgs = {
  filters?: InputMaybe<TUploadFileFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryUploadFolderArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryUploadFoldersArgs = {
  filters?: InputMaybe<TUploadFolderFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryUserProfileArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryUserProfilesArgs = {
  filters?: InputMaybe<TUserProfileFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<TUsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TQueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type TQueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<TUsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TRegion = {
  __typename?: 'Region';
  country?: Maybe<TCountryEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TRegionEntity = {
  __typename?: 'RegionEntity';
  attributes?: Maybe<TRegion>;
  id?: Maybe<Scalars['ID']>;
};

export type TRegionEntityResponse = {
  __typename?: 'RegionEntityResponse';
  data?: Maybe<TRegionEntity>;
};

export type TRegionEntityResponseCollection = {
  __typename?: 'RegionEntityResponseCollection';
  data: Array<TRegionEntity>;
  meta: TResponseCollectionMeta;
};

export type TRegionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TRegionFiltersInput>>>;
  country?: InputMaybe<TCountryFiltersInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TRegionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TRegionFiltersInput>>>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  slug?: InputMaybe<TStringFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TRegionInput = {
  country?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type TRegionRelationResponseCollection = {
  __typename?: 'RegionRelationResponseCollection';
  data: Array<TRegionEntity>;
};

export type TResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: TPagination;
};

export type TSitemapSitemap = {
  __typename?: 'SitemapSitemap';
  createdAt?: Maybe<Scalars['DateTime']>;
  delta?: Maybe<Scalars['Int']>;
  link_count?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  sitemap_string: Scalars['String'];
  type?: Maybe<TEnum_Sitemapsitemap_Type>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TSitemapSitemapCache = {
  __typename?: 'SitemapSitemapCache';
  createdAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  sitemap_id: Scalars['Int'];
  sitemap_json: Scalars['JSON'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TSitemapSitemapCacheEntity = {
  __typename?: 'SitemapSitemapCacheEntity';
  attributes?: Maybe<TSitemapSitemapCache>;
  id?: Maybe<Scalars['ID']>;
};

export type TSitemapSitemapCacheEntityResponse = {
  __typename?: 'SitemapSitemapCacheEntityResponse';
  data?: Maybe<TSitemapSitemapCacheEntity>;
};

export type TSitemapSitemapCacheEntityResponseCollection = {
  __typename?: 'SitemapSitemapCacheEntityResponseCollection';
  data: Array<TSitemapSitemapCacheEntity>;
  meta: TResponseCollectionMeta;
};

export type TSitemapSitemapCacheFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TSitemapSitemapCacheFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TSitemapSitemapCacheFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TSitemapSitemapCacheFiltersInput>>>;
  sitemap_id?: InputMaybe<TIntFilterInput>;
  sitemap_json?: InputMaybe<TJsonFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TSitemapSitemapCacheInput = {
  name?: InputMaybe<Scalars['String']>;
  sitemap_id?: InputMaybe<Scalars['Int']>;
  sitemap_json?: InputMaybe<Scalars['JSON']>;
};

export type TSitemapSitemapEntity = {
  __typename?: 'SitemapSitemapEntity';
  attributes?: Maybe<TSitemapSitemap>;
  id?: Maybe<Scalars['ID']>;
};

export type TSitemapSitemapEntityResponse = {
  __typename?: 'SitemapSitemapEntityResponse';
  data?: Maybe<TSitemapSitemapEntity>;
};

export type TSitemapSitemapEntityResponseCollection = {
  __typename?: 'SitemapSitemapEntityResponseCollection';
  data: Array<TSitemapSitemapEntity>;
  meta: TResponseCollectionMeta;
};

export type TSitemapSitemapFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TSitemapSitemapFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  delta?: InputMaybe<TIntFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  link_count?: InputMaybe<TIntFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TSitemapSitemapFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TSitemapSitemapFiltersInput>>>;
  sitemap_string?: InputMaybe<TStringFilterInput>;
  type?: InputMaybe<TStringFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TSitemapSitemapInput = {
  delta?: InputMaybe<Scalars['Int']>;
  link_count?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  sitemap_string?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<TEnum_Sitemapsitemap_Type>;
};

export type TStore = {
  __typename?: 'Store';
  alternateName?: Maybe<Scalars['String']>;
  catalogs?: Maybe<TCatalogRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  location?: Maybe<TLocationEntityResponse>;
  member?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Scalars['String']>;
  organization?: Maybe<TOrganizationEntityResponse>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  sameAs?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TStoreCatalogsArgs = {
  filters?: InputMaybe<TCatalogFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  publicationState?: InputMaybe<TPublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TStoreEntity = {
  __typename?: 'StoreEntity';
  attributes?: Maybe<TStore>;
  id?: Maybe<Scalars['ID']>;
};

export type TStoreEntityResponse = {
  __typename?: 'StoreEntityResponse';
  data?: Maybe<TStoreEntity>;
};

export type TStoreEntityResponseCollection = {
  __typename?: 'StoreEntityResponseCollection';
  data: Array<TStoreEntity>;
  meta: TResponseCollectionMeta;
};

export type TStoreFiltersInput = {
  alternateName?: InputMaybe<TStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TStoreFiltersInput>>>;
  catalogs?: InputMaybe<TCatalogFiltersInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  description?: InputMaybe<TStringFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  location?: InputMaybe<TLocationFiltersInput>;
  member?: InputMaybe<TStringFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TStoreFiltersInput>;
  openingHours?: InputMaybe<TStringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<TStoreFiltersInput>>>;
  organization?: InputMaybe<TOrganizationFiltersInput>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  sameAs?: InputMaybe<TStringFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  slug?: InputMaybe<TStringFilterInput>;
  telephone?: InputMaybe<TStringFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TStoreInput = {
  alternateName?: InputMaybe<Scalars['String']>;
  catalogs?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  description?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['ID']>;
  member?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  openingHours?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Scalars['ID']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sameAs?: InputMaybe<Scalars['String']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  telephone?: InputMaybe<Scalars['String']>;
};

export type TStringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  containsi?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  eq?: InputMaybe<Scalars['String']>;
  eqi?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  ne?: InputMaybe<Scalars['String']>;
  nei?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<TStringFilterInput>;
  notContains?: InputMaybe<Scalars['String']>;
  notContainsi?: InputMaybe<Scalars['String']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notNull?: InputMaybe<Scalars['Boolean']>;
  null?: InputMaybe<Scalars['Boolean']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type TTown = {
  __typename?: 'Town';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TTownEntity = {
  __typename?: 'TownEntity';
  attributes?: Maybe<TTown>;
  id?: Maybe<Scalars['ID']>;
};

export type TTownEntityResponse = {
  __typename?: 'TownEntityResponse';
  data?: Maybe<TTownEntity>;
};

export type TTownEntityResponseCollection = {
  __typename?: 'TownEntityResponseCollection';
  data: Array<TTownEntity>;
  meta: TResponseCollectionMeta;
};

export type TTownFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TTownFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TTownFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TTownFiltersInput>>>;
  publishedAt?: InputMaybe<TDateTimeFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  slug?: InputMaybe<TStringFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TTownInput = {
  name?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['DateTime']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
};

export type TUploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  ext?: Maybe<Scalars['String']>;
  formats?: Maybe<Scalars['JSON']>;
  hash: Scalars['String'];
  height?: Maybe<Scalars['Int']>;
  mime: Scalars['String'];
  name: Scalars['String'];
  previewUrl?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  provider_metadata?: Maybe<Scalars['JSON']>;
  related?: Maybe<Array<Maybe<TGenericMorph>>>;
  size: Scalars['Float'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  url: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
};

export type TUploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<TUploadFile>;
  id?: Maybe<Scalars['ID']>;
};

export type TUploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<TUploadFileEntity>;
};

export type TUploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<TUploadFileEntity>;
  meta: TResponseCollectionMeta;
};

export type TUploadFileFiltersInput = {
  alternativeText?: InputMaybe<TStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TUploadFileFiltersInput>>>;
  caption?: InputMaybe<TStringFilterInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  ext?: InputMaybe<TStringFilterInput>;
  folder?: InputMaybe<TUploadFolderFiltersInput>;
  folderPath?: InputMaybe<TStringFilterInput>;
  formats?: InputMaybe<TJsonFilterInput>;
  hash?: InputMaybe<TStringFilterInput>;
  height?: InputMaybe<TIntFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  mime?: InputMaybe<TStringFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TUploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TUploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<TStringFilterInput>;
  provider?: InputMaybe<TStringFilterInput>;
  provider_metadata?: InputMaybe<TJsonFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  size?: InputMaybe<TFloatFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
  url?: InputMaybe<TStringFilterInput>;
  width?: InputMaybe<TIntFilterInput>;
};

export type TUploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']>;
  caption?: InputMaybe<Scalars['String']>;
  ext?: InputMaybe<Scalars['String']>;
  folder?: InputMaybe<Scalars['ID']>;
  folderPath?: InputMaybe<Scalars['String']>;
  formats?: InputMaybe<Scalars['JSON']>;
  hash?: InputMaybe<Scalars['String']>;
  height?: InputMaybe<Scalars['Int']>;
  mime?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  previewUrl?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  provider_metadata?: InputMaybe<Scalars['JSON']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  size?: InputMaybe<Scalars['Float']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Int']>;
};

export type TUploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<TUploadFileEntity>;
};

export type TUploadFolder = {
  __typename?: 'UploadFolder';
  children?: Maybe<TUploadFolderRelationResponseCollection>;
  createdAt?: Maybe<Scalars['DateTime']>;
  files?: Maybe<TUploadFileRelationResponseCollection>;
  name: Scalars['String'];
  parent?: Maybe<TUploadFolderEntityResponse>;
  path: Scalars['String'];
  pathId: Scalars['Int'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type TUploadFolderChildrenArgs = {
  filters?: InputMaybe<TUploadFolderFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TUploadFolderFilesArgs = {
  filters?: InputMaybe<TUploadFileFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TUploadFolderEntity = {
  __typename?: 'UploadFolderEntity';
  attributes?: Maybe<TUploadFolder>;
  id?: Maybe<Scalars['ID']>;
};

export type TUploadFolderEntityResponse = {
  __typename?: 'UploadFolderEntityResponse';
  data?: Maybe<TUploadFolderEntity>;
};

export type TUploadFolderEntityResponseCollection = {
  __typename?: 'UploadFolderEntityResponseCollection';
  data: Array<TUploadFolderEntity>;
  meta: TResponseCollectionMeta;
};

export type TUploadFolderFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TUploadFolderFiltersInput>>>;
  children?: InputMaybe<TUploadFolderFiltersInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  files?: InputMaybe<TUploadFileFiltersInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TUploadFolderFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TUploadFolderFiltersInput>>>;
  parent?: InputMaybe<TUploadFolderFiltersInput>;
  path?: InputMaybe<TStringFilterInput>;
  pathId?: InputMaybe<TIntFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TUploadFolderInput = {
  children?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  files?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  name?: InputMaybe<Scalars['String']>;
  parent?: InputMaybe<Scalars['ID']>;
  path?: InputMaybe<Scalars['String']>;
  pathId?: InputMaybe<Scalars['Int']>;
};

export type TUploadFolderRelationResponseCollection = {
  __typename?: 'UploadFolderRelationResponseCollection';
  data: Array<TUploadFolderEntity>;
};

export type TUserProfile = {
  __typename?: 'UserProfile';
  createdAt?: Maybe<Scalars['DateTime']>;
  emailNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  phoneNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  selectedLocation?: Maybe<Scalars['JSON']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<TUsersPermissionsUserEntityResponse>;
};

export type TUserProfileEntity = {
  __typename?: 'UserProfileEntity';
  attributes?: Maybe<TUserProfile>;
  id?: Maybe<Scalars['ID']>;
};

export type TUserProfileEntityResponse = {
  __typename?: 'UserProfileEntityResponse';
  data?: Maybe<TUserProfileEntity>;
};

export type TUserProfileEntityResponseCollection = {
  __typename?: 'UserProfileEntityResponseCollection';
  data: Array<TUserProfileEntity>;
  meta: TResponseCollectionMeta;
};

export type TUserProfileFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TUserProfileFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  emailNotificationsEnabled?: InputMaybe<TBooleanFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  not?: InputMaybe<TUserProfileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TUserProfileFiltersInput>>>;
  phoneNotificationsEnabled?: InputMaybe<TBooleanFilterInput>;
  selectedLocation?: InputMaybe<TJsonFilterInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
  user?: InputMaybe<TUsersPermissionsUserFiltersInput>;
};

export type TUserProfileInput = {
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  phoneNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  selectedLocation?: InputMaybe<Scalars['JSON']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  user?: InputMaybe<Scalars['ID']>;
};

export type TUsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean'];
};

export type TUsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean'];
};

export type TUsersPermissionsLoginInput = {
  identifier: Scalars['String'];
  password: Scalars['String'];
  provider?: Scalars['String'];
};

export type TUsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']>;
  user: TUsersPermissionsMe;
};

export type TUsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<TUsersPermissionsMeRole>;
  userProfile?: Maybe<TUserProfileEntity>;
  username: Scalars['String'];
};

export type TUsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type TUsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean'];
};

export type TUsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  role?: Maybe<TUsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TUsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<TUsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']>;
};

export type TUsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<TStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<TUsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  not?: InputMaybe<TUsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TUsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<TUsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
};

export type TUsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<TUsersPermissionsPermissionEntity>;
};

export type TUsersPermissionsRegisterInput = {
  email: Scalars['String'];
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phoneNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type TUsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  permissions?: Maybe<TUsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  users?: Maybe<TUsersPermissionsUserRelationResponseCollection>;
};


export type TUsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<TUsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type TUsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<TUsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<TPaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type TUsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<TUsersPermissionsRole>;
  id?: Maybe<Scalars['ID']>;
};

export type TUsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<TUsersPermissionsRoleEntity>;
};

export type TUsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<TUsersPermissionsRoleEntity>;
  meta: TResponseCollectionMeta;
};

export type TUsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TUsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  description?: InputMaybe<TStringFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TUsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TUsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<TUsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<TStringFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
  users?: InputMaybe<TUsersPermissionsUserFiltersInput>;
};

export type TUsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  type?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type TUsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean'];
};

export type TUsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']>;
  confirmed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  role?: Maybe<TUsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userProfile?: Maybe<TUserProfileEntityResponse>;
  username: Scalars['String'];
};

export type TUsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<TUsersPermissionsUser>;
  id?: Maybe<Scalars['ID']>;
};

export type TUsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<TUsersPermissionsUserEntity>;
};

export type TUsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<TUsersPermissionsUserEntity>;
  meta: TResponseCollectionMeta;
};

export type TUsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<TUsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<TBooleanFilterInput>;
  confirmationToken?: InputMaybe<TStringFilterInput>;
  confirmed?: InputMaybe<TBooleanFilterInput>;
  createdAt?: InputMaybe<TDateTimeFilterInput>;
  email?: InputMaybe<TStringFilterInput>;
  id?: InputMaybe<TIdFilterInput>;
  name?: InputMaybe<TStringFilterInput>;
  not?: InputMaybe<TUsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<TUsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<TStringFilterInput>;
  phoneNumber?: InputMaybe<TStringFilterInput>;
  provider?: InputMaybe<TStringFilterInput>;
  resetPasswordToken?: InputMaybe<TStringFilterInput>;
  role?: InputMaybe<TUsersPermissionsRoleFiltersInput>;
  sitemap_exclude?: InputMaybe<TBooleanFilterInput>;
  updatedAt?: InputMaybe<TDateTimeFilterInput>;
  userProfile?: InputMaybe<TUserProfileFiltersInput>;
  username?: InputMaybe<TStringFilterInput>;
};

export type TUsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']>;
  confirmationToken?: InputMaybe<Scalars['String']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  email?: InputMaybe<Scalars['String']>;
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  provider?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['ID']>;
  selectedLocation?: InputMaybe<Scalars['JSON']>;
  sitemap_exclude?: InputMaybe<Scalars['Boolean']>;
  userProfile?: InputMaybe<Scalars['ID']>;
  username?: InputMaybe<Scalars['String']>;
};

export type TUsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<TUsersPermissionsUserEntity>;
};

export type TLoginMutationVariables = Exact<{
  identifier: Scalars['String'];
  password: Scalars['String'];
}>;


export type TLoginMutation = { __typename?: 'Mutation', login: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } };

export type TRegisterMutationVariables = Exact<{
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  phoneNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
  emailNotificationsEnabled?: InputMaybe<Scalars['Boolean']>;
}>;


export type TRegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, name?: string | null, phoneNumber?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } } };

export type TUpdateUserMeMutationVariables = Exact<{
  data: TUsersPermissionsUserInput;
}>;


export type TUpdateUserMeMutation = { __typename?: 'Mutation', updateMe: { __typename?: 'UsersPermissionsUserEntityResponse', data?: { __typename?: 'UsersPermissionsUserEntity', id?: string | null, attributes?: { __typename?: 'UsersPermissionsUser', username: string, email: string, confirmed?: boolean | null, blocked?: boolean | null, name?: string | null, phoneNumber?: string | null } | null } | null } };

export type TGetCatalogPageQueryVariables = Exact<{
  catalogId?: InputMaybe<Scalars['ID']>;
  distanceFilter?: InputMaybe<TDistanceFiltersInput>;
}>;


export type TGetCatalogPageQuery = { __typename?: 'Query', catalog?: { __typename?: 'CatalogEntityResponse', data?: { __typename?: 'CatalogEntity', attributes?: { __typename?: 'Catalog', checksum?: string | null, runFrom?: any | null, stores?: { __typename?: 'StoreEntityResponseCollection', data: Array<{ __typename?: 'StoreEntity', attributes?: { __typename?: 'Store', name?: string | null, organization?: { __typename?: 'OrganizationEntityResponse', data?: { __typename?: 'OrganizationEntity', attributes?: { __typename?: 'Organization', expectedCatalogsUpdateFrequency?: number | null, slug?: string | null, name?: string | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null } | null } | null } | null }> } | null, pages?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename?: 'Page', image?: string | null, position?: number | null } | null }> } | null } | null } | null } | null };

export type TGetDealerPageQueryVariables = Exact<{
  organizationSlug?: InputMaybe<Scalars['String']>;
  catalogsRunFrom?: InputMaybe<Scalars['DateTime']>;
  distanceFilter?: InputMaybe<TDistanceFiltersInput>;
}>;


export type TGetDealerPageQuery = { __typename?: 'Query', organizations?: { __typename?: 'OrganizationEntityResponseCollection', data: Array<{ __typename?: 'OrganizationEntity', attributes?: { __typename?: 'Organization', name?: string | null, description?: string | null, slug?: string | null, expectedCatalogsUpdateFrequency?: number | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, stores?: { __typename?: 'StoreEntityResponseCollection', data: Array<{ __typename?: 'StoreEntity', id?: string | null, attributes?: { __typename?: 'Store', name?: string | null, sameAs?: string | null, location?: { __typename?: 'LocationEntityResponse', data?: { __typename?: 'LocationEntity', attributes?: { __typename?: 'Location', address?: string | null, town?: { __typename?: 'TownEntityResponse', data?: { __typename?: 'TownEntity', attributes?: { __typename?: 'Town', name?: string | null } | null } | null } | null } | null } | null } | null, catalogs?: { __typename?: 'CatalogRelationResponseCollection', data: Array<{ __typename?: 'CatalogEntity', id?: string | null, attributes?: { __typename?: 'Catalog', runFrom?: any | null, checksum?: string | null, pages?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename?: 'Page', position?: number | null, image?: string | null } | null }> } | null } | null }> } | null } | null }> } | null } | null }> } | null };

export type TDealerPageOrganizationFragmentFragment = { __typename?: 'OrganizationEntity', attributes?: { __typename?: 'Organization', name?: string | null, description?: string | null, slug?: string | null, expectedCatalogsUpdateFrequency?: number | null, logo?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, stores?: { __typename?: 'StoreEntityResponseCollection', data: Array<{ __typename?: 'StoreEntity', id?: string | null, attributes?: { __typename?: 'Store', name?: string | null, sameAs?: string | null, location?: { __typename?: 'LocationEntityResponse', data?: { __typename?: 'LocationEntity', attributes?: { __typename?: 'Location', address?: string | null, town?: { __typename?: 'TownEntityResponse', data?: { __typename?: 'TownEntity', attributes?: { __typename?: 'Town', name?: string | null } | null } | null } | null } | null } | null } | null, catalogs?: { __typename?: 'CatalogRelationResponseCollection', data: Array<{ __typename?: 'CatalogEntity', id?: string | null, attributes?: { __typename?: 'Catalog', runFrom?: any | null, checksum?: string | null, pages?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename?: 'Page', position?: number | null, image?: string | null } | null }> } | null } | null }> } | null } | null }> } | null } | null };

export type TGetFaqPageQueryVariables = Exact<{ [key: string]: never; }>;


export type TGetFaqPageQuery = { __typename?: 'Query', faqPage?: { __typename?: 'FaqPageEntityResponse', data?: { __typename?: 'FaqPageEntity', attributes?: { __typename?: 'FaqPage', markdown?: string | null } | null } | null } | null };

export type TGetLandingPageQueryVariables = Exact<{
  catalogsRunFrom?: InputMaybe<Scalars['DateTime']>;
  useNearByStores: Scalars['Boolean'];
  userLongitude: Scalars['Float'];
  userLatitude: Scalars['Float'];
  distanceLimit?: InputMaybe<Scalars['Float']>;
}>;


export type TGetLandingPageQuery = { __typename?: 'Query', landingPage?: { __typename?: 'LandingPageEntityResponse', data?: { __typename?: 'LandingPageEntity', attributes?: { __typename?: 'LandingPage', categories?: { __typename?: 'CategoryRelationResponseCollection', data: Array<{ __typename?: 'CategoryEntity', attributes?: { __typename?: 'Category', name?: string | null, slug?: string | null } | null }> } | null, carouselBanner?: Array<{ __typename?: 'ComponentMiscCarouselBanner', url?: string | null, title?: string | null, subtitle?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null, offerCollection?: { __typename?: 'ComponentMiscOfferCollection', title?: string | null, offerings?: Array<{ __typename?: 'ComponentMiscOrgs', name?: string | null, active?: boolean | null, organization?: { __typename?: 'OrganizationEntityResponse', data?: { __typename?: 'OrganizationEntity', attributes?: { __typename?: 'Organization', expectedCatalogsUpdateFrequency?: number | null, name?: string | null, slug?: string | null, categories?: { __typename?: 'CategoryRelationResponseCollection', data: Array<{ __typename?: 'CategoryEntity', attributes?: { __typename?: 'Category', slug?: string | null } | null }> } | null, nearbyStores?: { __typename?: 'StoreEntityResponseCollection', data?: Array<{ __typename?: 'StoreEntity', attributes?: { __typename?: 'Store', name?: string | null } | null }> } | null, stores?: { __typename?: 'StoreEntityResponseCollection', data: Array<{ __typename?: 'StoreEntity', attributes?: { __typename?: 'Store', catalogs?: { __typename?: 'CatalogRelationResponseCollection', data: Array<{ __typename?: 'CatalogEntity', id?: string | null, attributes?: { __typename?: 'Catalog', runFrom?: any | null, checksum?: string | null, pages?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename?: 'Page', position?: number | null, image?: string | null } | null }> } | null } | null }> } | null } | null }> } | null } | null } | null } | null } | null> | null } | null, partners?: Array<{ __typename?: 'ComponentMiscPartners', linkLabel?: string | null, linkUrl?: string | null } | null> | null } | null } | null } | null };

export type TCarouselBannerFragmentFragment = { __typename?: 'ComponentMiscCarouselBanner', url?: string | null, title?: string | null, subtitle?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null };

export type TOfferCollectionFragmentFragment = { __typename?: 'ComponentMiscOfferCollection', title?: string | null, offerings?: Array<{ __typename?: 'ComponentMiscOrgs', name?: string | null, active?: boolean | null, organization?: { __typename?: 'OrganizationEntityResponse', data?: { __typename?: 'OrganizationEntity', attributes?: { __typename?: 'Organization', expectedCatalogsUpdateFrequency?: number | null, name?: string | null, slug?: string | null, categories?: { __typename?: 'CategoryRelationResponseCollection', data: Array<{ __typename?: 'CategoryEntity', attributes?: { __typename?: 'Category', slug?: string | null } | null }> } | null, nearbyStores?: { __typename?: 'StoreEntityResponseCollection', data?: Array<{ __typename?: 'StoreEntity', attributes?: { __typename?: 'Store', name?: string | null } | null }> } | null, stores?: { __typename?: 'StoreEntityResponseCollection', data: Array<{ __typename?: 'StoreEntity', attributes?: { __typename?: 'Store', catalogs?: { __typename?: 'CatalogRelationResponseCollection', data: Array<{ __typename?: 'CatalogEntity', id?: string | null, attributes?: { __typename?: 'Catalog', runFrom?: any | null, checksum?: string | null, pages?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename?: 'Page', position?: number | null, image?: string | null } | null }> } | null } | null }> } | null } | null }> } | null } | null } | null } | null } | null> | null };

export type TOrganizationFragmentFragment = { __typename?: 'OrganizationEntity', attributes?: { __typename?: 'Organization', expectedCatalogsUpdateFrequency?: number | null, name?: string | null, slug?: string | null, categories?: { __typename?: 'CategoryRelationResponseCollection', data: Array<{ __typename?: 'CategoryEntity', attributes?: { __typename?: 'Category', slug?: string | null } | null }> } | null, nearbyStores?: { __typename?: 'StoreEntityResponseCollection', data?: Array<{ __typename?: 'StoreEntity', attributes?: { __typename?: 'Store', name?: string | null } | null }> } | null, stores?: { __typename?: 'StoreEntityResponseCollection', data: Array<{ __typename?: 'StoreEntity', attributes?: { __typename?: 'Store', catalogs?: { __typename?: 'CatalogRelationResponseCollection', data: Array<{ __typename?: 'CatalogEntity', id?: string | null, attributes?: { __typename?: 'Catalog', runFrom?: any | null, checksum?: string | null, pages?: { __typename?: 'PageRelationResponseCollection', data: Array<{ __typename?: 'PageEntity', attributes?: { __typename?: 'Page', position?: number | null, image?: string | null } | null }> } | null } | null }> } | null } | null }> } | null } | null };

export type TGetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type TGetMeQuery = { __typename?: 'Query', me?: { __typename?: 'UsersPermissionsMe', id: string, username: string, email?: string | null, confirmed?: boolean | null, blocked?: boolean | null, role?: { __typename?: 'UsersPermissionsMeRole', id: string, name: string, description?: string | null, type?: string | null } | null } | null };

export type TGetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TGetRegionsQuery = { __typename?: 'Query', regions?: { __typename?: 'RegionEntityResponseCollection', data: Array<{ __typename?: 'RegionEntity', id?: string | null, attributes?: { __typename?: 'Region', name?: string | null, slug?: string | null } | null }> } | null };

export const DealerPageOrganizationFragmentFragmentDoc = gql`
    fragment DealerPageOrganizationFragment on OrganizationEntity {
  attributes {
    name
    description
    slug
    expectedCatalogsUpdateFrequency
    logo {
      data {
        attributes {
          url
        }
      }
    }
    stores(
      pagination: {pageSize: 12, page: 1}
      filters: {and: [{not: {catalogs: {id: null}}}, {catalogs: {runFrom: {gt: $catalogsRunFrom}}}]}
      distanceFilter: $distanceFilter
    ) {
      data {
        id
        attributes {
          name
          sameAs
          location {
            data {
              attributes {
                address
                town {
                  data {
                    attributes {
                      name
                    }
                  }
                }
              }
            }
          }
          catalogs(
            sort: "runFrom:desc"
            pagination: {pageSize: 10}
            filters: {and: [{not: {id: null}}, {runFrom: {gt: $catalogsRunFrom}}]}
          ) {
            data {
              id
              attributes {
                runFrom
                checksum
                pages(pagination: {pageSize: 1}, sort: "position:asc") {
                  data {
                    attributes {
                      position
                      image
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const CarouselBannerFragmentFragmentDoc = gql`
    fragment CarouselBannerFragment on ComponentMiscCarouselBanner {
  url
  title
  subtitle
  image {
    data {
      attributes {
        url
      }
    }
  }
}
    `;
export const OrganizationFragmentFragmentDoc = gql`
    fragment OrganizationFragment on OrganizationEntity {
  attributes {
    expectedCatalogsUpdateFrequency
    name
    slug
    categories {
      data {
        attributes {
          slug
        }
      }
    }
    nearbyStores: stores(
      pagination: {pageSize: 12, page: 1}
      filters: {and: [{not: {catalogs: {id: null}}}, {catalogs: {runFrom: {gt: $catalogsRunFrom}}}]}
      distanceFilter: {longitude: $userLongitude, latitude: $userLatitude, distance: $distanceLimit}
    ) {
      data @include(if: $useNearByStores) {
        attributes {
          name
        }
      }
    }
    stores(
      pagination: {pageSize: 1, page: 1}
      filters: {and: [{not: {catalogs: {id: null}}}, {catalogs: {runFrom: {gt: $catalogsRunFrom}}}]}
      distanceFilter: {longitude: $userLongitude, latitude: $userLatitude, distance: null}
    ) {
      data {
        attributes {
          catalogs(
            sort: "runFrom:desc"
            pagination: {pageSize: 1}
            filters: {and: [{not: {id: null}}, {runFrom: {gt: $catalogsRunFrom}}]}
          ) {
            data {
              id
              attributes {
                runFrom
                checksum
                pages(pagination: {pageSize: 1}, sort: "position:asc") {
                  data {
                    attributes {
                      position
                      image
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const OfferCollectionFragmentFragmentDoc = gql`
    fragment OfferCollectionFragment on ComponentMiscOfferCollection {
  title
  offerings(pagination: {pageSize: 30, page: 1}, filters: {active: {eq: true}}) {
    name
    active
    organization {
      data {
        ...OrganizationFragment
      }
    }
  }
}
    ${OrganizationFragmentFragmentDoc}`;
export const LoginDocument = gql`
    mutation login($identifier: String!, $password: String!) {
  login(input: {identifier: $identifier, password: $password}) {
    jwt
    user {
      id
      username
      email
      confirmed
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
}
    `;
export type TLoginMutationFn = Apollo.MutationFunction<TLoginMutation, TLoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<TLoginMutation, TLoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TLoginMutation, TLoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<TLoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<TLoginMutation, TLoginMutationVariables>;
export const RegisterDocument = gql`
    mutation register($username: String!, $email: String!, $password: String!, $name: String, $phoneNumber: String, $phoneNotificationsEnabled: Boolean, $emailNotificationsEnabled: Boolean) {
  register(
    input: {username: $username, email: $email, password: $password, name: $name, phoneNumber: $phoneNumber, phoneNotificationsEnabled: $phoneNotificationsEnabled, emailNotificationsEnabled: $emailNotificationsEnabled}
  ) {
    jwt
    user {
      id
      username
      email
      name
      phoneNumber
      confirmed
      blocked
      role {
        id
        name
        description
        type
      }
    }
  }
}
    `;
export type TRegisterMutationFn = Apollo.MutationFunction<TRegisterMutation, TRegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      username: // value for 'username'
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      name: // value for 'name'
 *      phoneNumber: // value for 'phoneNumber'
 *      phoneNotificationsEnabled: // value for 'phoneNotificationsEnabled'
 *      emailNotificationsEnabled: // value for 'emailNotificationsEnabled'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<TRegisterMutation, TRegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TRegisterMutation, TRegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<TRegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<TRegisterMutation, TRegisterMutationVariables>;
export const UpdateUserMeDocument = gql`
    mutation updateUserMe($data: UsersPermissionsUserInput!) {
  updateMe(data: $data) {
    data {
      id
      attributes {
        username
        email
        confirmed
        blocked
        name
        phoneNumber
      }
    }
  }
}
    `;
export type TUpdateUserMeMutationFn = Apollo.MutationFunction<TUpdateUserMeMutation, TUpdateUserMeMutationVariables>;

/**
 * __useUpdateUserMeMutation__
 *
 * To run a mutation, you first call `useUpdateUserMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMeMutation, { data, loading, error }] = useUpdateUserMeMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateUserMeMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateUserMeMutation, TUpdateUserMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TUpdateUserMeMutation, TUpdateUserMeMutationVariables>(UpdateUserMeDocument, options);
      }
export type UpdateUserMeMutationHookResult = ReturnType<typeof useUpdateUserMeMutation>;
export type UpdateUserMeMutationResult = Apollo.MutationResult<TUpdateUserMeMutation>;
export type UpdateUserMeMutationOptions = Apollo.BaseMutationOptions<TUpdateUserMeMutation, TUpdateUserMeMutationVariables>;
export const GetCatalogPageDocument = gql`
    query GetCatalogPage($catalogId: ID, $distanceFilter: DistanceFiltersInput) {
  catalog(id: $catalogId) {
    data {
      attributes {
        checksum
        runFrom
        stores(pagination: {pageSize: 1}, distanceFilter: $distanceFilter) {
          data {
            attributes {
              name
              organization {
                data {
                  attributes {
                    expectedCatalogsUpdateFrequency
                    slug
                    name
                    logo {
                      data {
                        attributes {
                          url
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        pages(sort: "position:asc", pagination: {pageSize: 100}) {
          data {
            attributes {
              image
              position
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCatalogPageQuery__
 *
 * To run a query within a React component, call `useGetCatalogPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCatalogPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCatalogPageQuery({
 *   variables: {
 *      catalogId: // value for 'catalogId'
 *      distanceFilter: // value for 'distanceFilter'
 *   },
 * });
 */
export function useGetCatalogPageQuery(baseOptions?: Apollo.QueryHookOptions<TGetCatalogPageQuery, TGetCatalogPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TGetCatalogPageQuery, TGetCatalogPageQueryVariables>(GetCatalogPageDocument, options);
      }
export function useGetCatalogPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetCatalogPageQuery, TGetCatalogPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TGetCatalogPageQuery, TGetCatalogPageQueryVariables>(GetCatalogPageDocument, options);
        }
export type GetCatalogPageQueryHookResult = ReturnType<typeof useGetCatalogPageQuery>;
export type GetCatalogPageLazyQueryHookResult = ReturnType<typeof useGetCatalogPageLazyQuery>;
export type GetCatalogPageQueryResult = Apollo.QueryResult<TGetCatalogPageQuery, TGetCatalogPageQueryVariables>;
export const GetDealerPageDocument = gql`
    query GetDealerPage($organizationSlug: String, $catalogsRunFrom: DateTime, $distanceFilter: DistanceFiltersInput) {
  organizations(
    pagination: {pageSize: 30}
    filters: {and: [{slug: {eq: $organizationSlug}}]}
  ) {
    data {
      ...DealerPageOrganizationFragment
    }
  }
}
    ${DealerPageOrganizationFragmentFragmentDoc}`;

/**
 * __useGetDealerPageQuery__
 *
 * To run a query within a React component, call `useGetDealerPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDealerPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealerPageQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      catalogsRunFrom: // value for 'catalogsRunFrom'
 *      distanceFilter: // value for 'distanceFilter'
 *   },
 * });
 */
export function useGetDealerPageQuery(baseOptions?: Apollo.QueryHookOptions<TGetDealerPageQuery, TGetDealerPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TGetDealerPageQuery, TGetDealerPageQueryVariables>(GetDealerPageDocument, options);
      }
export function useGetDealerPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetDealerPageQuery, TGetDealerPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TGetDealerPageQuery, TGetDealerPageQueryVariables>(GetDealerPageDocument, options);
        }
export type GetDealerPageQueryHookResult = ReturnType<typeof useGetDealerPageQuery>;
export type GetDealerPageLazyQueryHookResult = ReturnType<typeof useGetDealerPageLazyQuery>;
export type GetDealerPageQueryResult = Apollo.QueryResult<TGetDealerPageQuery, TGetDealerPageQueryVariables>;
export const GetFaqPageDocument = gql`
    query GetFaqPage {
  faqPage {
    data {
      attributes {
        markdown
      }
    }
  }
}
    `;

/**
 * __useGetFaqPageQuery__
 *
 * To run a query within a React component, call `useGetFaqPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFaqPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFaqPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFaqPageQuery(baseOptions?: Apollo.QueryHookOptions<TGetFaqPageQuery, TGetFaqPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TGetFaqPageQuery, TGetFaqPageQueryVariables>(GetFaqPageDocument, options);
      }
export function useGetFaqPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetFaqPageQuery, TGetFaqPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TGetFaqPageQuery, TGetFaqPageQueryVariables>(GetFaqPageDocument, options);
        }
export type GetFaqPageQueryHookResult = ReturnType<typeof useGetFaqPageQuery>;
export type GetFaqPageLazyQueryHookResult = ReturnType<typeof useGetFaqPageLazyQuery>;
export type GetFaqPageQueryResult = Apollo.QueryResult<TGetFaqPageQuery, TGetFaqPageQueryVariables>;
export const GetLandingPageDocument = gql`
    query GetLandingPage($catalogsRunFrom: DateTime, $useNearByStores: Boolean!, $userLongitude: Float!, $userLatitude: Float!, $distanceLimit: Float) {
  landingPage {
    data {
      attributes {
        categories {
          data {
            attributes {
              name
              slug
            }
          }
        }
        carouselBanner {
          ...CarouselBannerFragment
        }
        offerCollection {
          ...OfferCollectionFragment
        }
        partners {
          linkLabel
          linkUrl
        }
      }
    }
  }
}
    ${CarouselBannerFragmentFragmentDoc}
${OfferCollectionFragmentFragmentDoc}`;

/**
 * __useGetLandingPageQuery__
 *
 * To run a query within a React component, call `useGetLandingPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingPageQuery({
 *   variables: {
 *      catalogsRunFrom: // value for 'catalogsRunFrom'
 *      useNearByStores: // value for 'useNearByStores'
 *      userLongitude: // value for 'userLongitude'
 *      userLatitude: // value for 'userLatitude'
 *      distanceLimit: // value for 'distanceLimit'
 *   },
 * });
 */
export function useGetLandingPageQuery(baseOptions: Apollo.QueryHookOptions<TGetLandingPageQuery, TGetLandingPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TGetLandingPageQuery, TGetLandingPageQueryVariables>(GetLandingPageDocument, options);
      }
export function useGetLandingPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetLandingPageQuery, TGetLandingPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TGetLandingPageQuery, TGetLandingPageQueryVariables>(GetLandingPageDocument, options);
        }
export type GetLandingPageQueryHookResult = ReturnType<typeof useGetLandingPageQuery>;
export type GetLandingPageLazyQueryHookResult = ReturnType<typeof useGetLandingPageLazyQuery>;
export type GetLandingPageQueryResult = Apollo.QueryResult<TGetLandingPageQuery, TGetLandingPageQueryVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    id
    username
    email
    confirmed
    blocked
    role {
      id
      name
      description
      type
    }
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<TGetMeQuery, TGetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TGetMeQuery, TGetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetMeQuery, TGetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TGetMeQuery, TGetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<TGetMeQuery, TGetMeQueryVariables>;
export const GetRegionsDocument = gql`
    query GetRegions {
  regions(sort: ["name:asc"], pagination: {pageSize: 500}) {
    data {
      id
      attributes {
        name
        slug
      }
    }
  }
}
    `;

/**
 * __useGetRegionsQuery__
 *
 * To run a query within a React component, call `useGetRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegionsQuery(baseOptions?: Apollo.QueryHookOptions<TGetRegionsQuery, TGetRegionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TGetRegionsQuery, TGetRegionsQueryVariables>(GetRegionsDocument, options);
      }
export function useGetRegionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetRegionsQuery, TGetRegionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TGetRegionsQuery, TGetRegionsQueryVariables>(GetRegionsDocument, options);
        }
export type GetRegionsQueryHookResult = ReturnType<typeof useGetRegionsQuery>;
export type GetRegionsLazyQueryHookResult = ReturnType<typeof useGetRegionsLazyQuery>;
export type GetRegionsQueryResult = Apollo.QueryResult<TGetRegionsQuery, TGetRegionsQueryVariables>;